import { render, staticRenderFns } from "./commonTitleWidge.vue?vue&type=template&id=2ba2b76c&scoped=true"
import script from "./commonTitleWidge.vue?vue&type=script&lang=js"
export * from "./commonTitleWidge.vue?vue&type=script&lang=js"
import style0 from "./commonTitleWidge.vue?vue&type=style&index=0&id=2ba2b76c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba2b76c",
  null
  
)

export default component.exports